import { type Middleware } from "openapi-fetch";

import { HTTP_STATUS } from "@/constants";
import { throwApiHttpErrorMessage } from "@/utils/errors";

export const authMiddleware: Middleware = {
  onRequest({ request }) {
    request.headers.set(
      "Authorizationjwt",
      `Bearer ${localStorage.getItem("token")}`,
    );
    return request;
  },
};

export const errorMiddleware: Middleware = {
  async onResponse({ response }) {
    if (
      response.status >= HTTP_STATUS.OK &&
      response.status < HTTP_STATUS.MULTIPLE_CHOICES
    ) {
      return response;
    }
    throwApiHttpErrorMessage(await response.json());
  },
};
